export default {
  template: require('./signin.html'),
  controller: 'SigninCtrl',
  controllerAs: 'signin',
  windowClass: 'modal-sm',
  windowTemplateUrl: '/modals/default/modal-container.html'
}



// WEBPACK FOOTER //
// ./project/modals/signin/signin.config.js